import type { ProductQuery } from "../../../__generated__/graphql";

type Product = NonNullable<ProductQuery["product"]>;
type ProductMenus = Product["menus"];

interface ProductMenuListProps {
  menus: ProductMenus | null | undefined;
}

const ProductMenuList = ({ menus }: ProductMenuListProps) => {
  if (!menus || menus.length === 0) return null;

  return (
    <div className="w-full bg-white">
      <div className="px-5 py-4">
        <div className="text-black text-lg font-semibold">
          🥘 구성 메뉴
        </div>
      </div>
      <div className="px-5 pb-4 space-y-3">
        {[...menus].reverse().map((menu) => (
          <div key={menu.id} className="py-2 border-b last:border-0">
            <div className="flex items-center justify-between mb-1">
              <span className="text-gray-900 font-medium text-base">
                {menu.menu?.name}
              </span>
              <div className="flex items-center space-x-3">
                <span className="text-gray-600 text-sm">
                  정가 {menu.menu?.price.toLocaleString()}원
                </span>
                <span className="text-gray-800 font-semibold">
                  x{menu.quantity}
                </span>
              </div>
            </div>
            {menu.menu?.description && (
              <p className="text-sm text-gray-500 mt-1">
                {menu.menu.description}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductMenuList;
